import HomeNavbar from "../components/HomeNavbar";
import HomeFooter from "../components/HomeFooter";
import "../components/HomeHF.css";

export default function TermsOfService() {
  return (
    <div>
        <HomeNavbar/>

        <main class="container-pagecomp">
            
            
            <section>
            <h1>Terms of Service</h1>
            <p class="updated">Last Updated: May 9, 2026</p>

            <p>
                Welcome to <strong>CreatorComment</strong>.
            </p>

            <p>
                By accessing or using CreatorComment, you agree to these Terms of Service.
            </p>
            </section>

            <section>
            <h2>1. Overview</h2>

            <p>
                CreatorComment is an AI-powered platform that helps creators analyze
                YouTube comments and generate actionable insights such as:
            </p>

            <ul>
                <li>Reply suggestions</li>
                <li>Content ideas</li>
                <li>Audience insights</li>
                <li>Engagement recommendations</li>
            </ul>
            </section>

            <section>
            <h2>2. Eligibility</h2>

            <p>
                You must be at least 13 years old to use the service.
            </p>

            <p>By using CreatorComment, you confirm that:</p>

            <ul>
                <li>You can legally enter into agreements</li>
                <li>You will comply with all applicable laws</li>
            </ul>
            </section>

            <section>
            <h2>3. User Accounts</h2>

            <p>Users may be required to:</p>

            <ul>
                <li>Create an account</li>
                <li>Log in with Google or other providers</li>
            </ul>

            <p>You are responsible for:</p>

            <ul>
                <li>Maintaining account security</li>
                <li>All activity under your account</li>
            </ul>
            </section>

            <section>
            <h2>4. Subscription &amp; Credits</h2>

            <p>CreatorComment may offer:</p>

            <ul>
                <li>Free plans</li>
                <li>Paid subscriptions</li>
                <li>Credit-based usage</li>
            </ul>

            <p>Credits may be used for:</p>

            <ul>
                <li>Video analysis</li>
                <li>Deep analysis</li>
                <li>Playlist analysis</li>
                <li>Premium AI features</li>
            </ul>

            <p>
                Unused credits may expire according to the active subscription plan.
            </p>
            </section>

            <section>
            <h2>5. Acceptable Use</h2>

            <p>You agree NOT to:</p>

            <ul>
                <li>Abuse or overload the platform</li>
                <li>Attempt unauthorized access</li>
                <li>Scrape or misuse data unlawfully</li>
                <li>Violate YouTube policies or third-party policies</li>
            </ul>
            </section>

            <section>
            <h2>6. AI-Generated Content</h2>

            <p>
                CreatorComment uses AI-generated insights and suggestions.
            </p>

            <p>We do not guarantee:</p>

            <ul>
                <li>Accuracy</li>
                <li>Completeness</li>
                <li>Business outcomes</li>
                <li>Subscriber growth</li>
            </ul>

            <p>
                Users are responsible for reviewing AI-generated responses before
                posting publicly.
            </p>
            </section>

            <section>
            <h2>7. Third-Party Services</h2>

            <p>CreatorComment may integrate with:</p>

            <ul>
                <li>YouTube</li>
                <li>Firebase</li>
                <li>OpenAI</li>
                <li>Google APIs</li>
            </ul>

            <p>
                We are not responsible for third-party outages or policy changes.
            </p>
            </section>

            <section>
            <h2>8. Intellectual Property</h2>

            <p>
                All CreatorComment branding, software, and content are owned by
                CreatorComment.
            </p>

            <p>Users may not:</p>

            <ul>
                <li>Copy</li>
                <li>Resell</li>
                <li>Reverse engineer</li>
                <li>Redistribute</li>
            </ul>

            <p>Without permission.</p>
            </section>

            <section>
            <h2>9. Termination</h2>

            <p>
                We reserve the right to suspend or terminate accounts that:
            </p>

            <ul>
                <li>Abuse the service</li>
                <li>Violate policies</li>
                <li>Engage in fraudulent activity</li>
            </ul>
            </section>

            <section>
            <h2>10. Limitation of Liability</h2>

            <p>
                CreatorComment is provided "as is" without warranties.
            </p>

            <p>We are not liable for:</p>

            <ul>
                <li>Lost revenue</li>
                <li>Creator performance</li>
                <li>Platform issues</li>
                <li>Data loss</li>
                <li>AI inaccuracies</li>
            </ul>
            </section>

            <section>
            <h2>11. Changes to Terms</h2>

            <p>
                We may update these Terms at any time.
            </p>

            <p>
                Continued use of the platform means you accept updated terms.
            </p>
            </section>

            <section>
            <h2>12. Contact</h2>

            <p>For questions, contact:</p>

            <p>
                <a href="mailto:creatorcommentweb@gmail.com">
                creatorcommentweb@gmail.com
                </a>
            </p>
            </section>

        </main>

      <HomeFooter/>
    </div>
  );
}